/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TrashIcon = ({ className , color }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M21.2143 3.53171H19.6429H16.5V1.28171C16.5 0.867523 16.1482 0.531708 15.7143 0.531708H6.28571C5.85181 0.531708 5.5 0.867523 5.5 1.28171V3.53171H2.35714H0.785714C0.351807 3.53171 0 3.86752 0 4.28171C0 4.69589 0.351807 5.03171 0.785714 5.03171H1.63948L2.8862 18.1212C3.07111 20.0654 4.75303 21.5317 6.79865 21.5317H15.2013C17.247 21.5317 18.9289 20.0654 19.1138 18.1212L20.3605 5.03171H21.2143C21.6482 5.03171 22 4.69589 22 4.28171C22 3.86752 21.6482 3.53171 21.2143 3.53171ZM7.07143 2.03171H14.9286V3.53171H7.07143V2.03171ZM17.5485 17.9857C17.4376 19.1521 16.4286 20.0317 15.2013 20.0317H6.79865C5.57136 20.0317 4.56236 19.1521 4.45149 17.9857L3.21767 5.03171H6.28571H15.7143H18.7823L17.5485 17.9857ZM15.7143 7.28171V17.0317C15.7143 17.4459 15.3625 17.7817 14.9286 17.7817C14.4947 17.7817 14.1429 17.4459 14.1429 17.0317V7.28171C14.1429 6.86752 14.4947 6.53171 14.9286 6.53171C15.3625 6.53171 15.7143 6.86752 15.7143 7.28171ZM11.7857 7.28171V17.0317C11.7857 17.4459 11.4339 17.7817 11 17.7817C10.5661 17.7817 10.2143 17.4459 10.2143 17.0317V7.28171C10.2143 6.86752 10.5661 6.53171 11 6.53171C11.4339 6.53171 11.7857 6.86752 11.7857 7.28171ZM7.85714 7.28171V17.0317C7.85714 17.4459 7.50534 17.7817 7.07143 17.7817C6.63752 17.7817 6.28571 17.4459 6.28571 17.0317V7.28171C6.28571 6.86752 6.63752 6.53171 7.07143 6.53171C7.50534 6.53171 7.85714 6.86752 7.85714 7.28171Z"
        fill= {color? color :"white"}
      />
    </svg>
  )
}
